import {
  FORCE_INTERACTIVE_LOGIN_KEY,
  SESSION_ENDED_KEY,
} from "./session.constants";

export function isSessionEnded() {
  try {
    return localStorage.getItem(SESSION_ENDED_KEY) === "true";
  } catch {
    return false;
  }
}

export function setSessionEnded() {
  try {
    localStorage.setItem(SESSION_ENDED_KEY, "true");
  } catch {
    /* ignore */
  }
}

export function clearSessionEnded() {
  try {
    localStorage.removeItem(SESSION_ENDED_KEY);
    localStorage.removeItem(FORCE_INTERACTIVE_LOGIN_KEY);
  } catch {
    /* ignore */
  }
}

export function isForceInteractiveLogin() {
  try {
    return localStorage.getItem(FORCE_INTERACTIVE_LOGIN_KEY) === "true";
  } catch {
    return false;
  }
}

export function setForceInteractiveLogin() {
  try {
    localStorage.setItem(FORCE_INTERACTIVE_LOGIN_KEY, "true");
  } catch {
    /* ignore */
  }
}

export function isOnGoodbyePage() {
  const path = window.location.pathname || "";
  return path === "/goodbye" || path.endsWith("/goodbye");
}

export function clearClientAuthStorage() {
  try {
    localStorage.removeItem("user");
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
}

/**
 * Back-forward cache only: a typed URL is a normal load and must try Entra SSO.
 */
export function enforceSessionEndedGuard() {
  if (!isSessionEnded() || isOnGoodbyePage()) {
    return false;
  }

  clearClientAuthStorage();
  window.location.replace(`${window.location.origin}/goodbye`);
  return true;
}

export function initSessionEndedPageshowGuard() {
  window.addEventListener("pageshow", (event) => {
    if (!isSessionEnded() || isOnGoodbyePage()) {
      return;
    }

    if (event.persisted) {
      enforceSessionEndedGuard();
    }
  });
}
